// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__309Md","selects":"Documents_selects__1Q38H"};